import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children, allowDuringPasswordReset = false }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div
        className="min-h-screen flex items-center justify-center"
        style={{ background: "#F5EFE6", color: "#8C9E8A" }}
        data-testid="auth-loading"
      >
        <div className="se-card text-center">Loading session…</div>
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  if (
    user.force_password_change &&
    !allowDuringPasswordReset &&
    location.pathname !== "/change-password"
  ) {
    return <Navigate to="/change-password" replace />;
  }
  return children;
}
